import { Typography, Box } from "@mui/material"
import { useTheme } from '@mui/material/styles';

export default function ErrorWrapper({ sx, children, message, showMessage }) {
    const theme = useTheme();
    return (
        <Box sx={sx}>
            {children}
            {showMessage ? (
                <Typography variant="caption" sx={{ color: theme.palette.error.main, pl: 1 }}>
                    {message}
                </Typography>
            ) : ""}

        </Box>
    )
}